import React from 'react';
import { styled } from '@compiled/react';
import Spinner, { type SpinnerProps } from '@atlaskit/spinner';

export default function LoadingSpinner(props: SpinnerProps) {
	return (
		<SpinnerWrapper>
			<Spinner {...props} />
		</SpinnerWrapper>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SpinnerWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
});
